import { render, staticRenderFns } from "./BaseCodeRun.vue?vue&type=template&id=2c637de5&scoped=true&"
import script from "./BaseCodeRun.vue?vue&type=script&lang=js&"
export * from "./BaseCodeRun.vue?vue&type=script&lang=js&"
import style0 from "./BaseCodeRun.vue?vue&type=style&index=0&id=2c637de5&prod&lang=scss&scoped=true&"
import style1 from "./BaseCodeRun.vue?vue&type=style&index=1&id=2c637de5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c637de5",
  null
  
)

export default component.exports